(ns app.components.tables.views
  (:require [app.components.checkbox.views :as checkbox]
            [app.components.icons.views :refer [close-icon]]
            [app.components.input-field.views :refer [label-text-field]]
            [app.components.menus.views :refer [table-item-menu-component]]
            [app.components.tables.styles :refer [close-icon-span-style
                                                  product-form-name-component
                                                  table-body-style table-cell-style table-head-style table-header-1-style
                                                  table-row-style table-style table-wrapper-style]]
            [re-com.core :refer [h-box v-box]]
            [reagent-mui.material.paper :refer [paper]]
            [reagent-mui.material.table :refer [table]]
            [reagent-mui.material.table-body :refer [table-body]]
            [reagent-mui.material.table-cell :refer [table-cell]]
            [reagent-mui.material.table-container :refer [table-container]]
            [reagent-mui.material.table-head :refer [table-head]]
            [reagent-mui.material.table-row :refer [table-row]]
            [reagent-mui.material.table-sort-label :refer [table-sort-label]]
            [reagent.core  :as r]))

(defn sort-table-by [column data sort-direction]
  (if (= sort-direction :asc)
    (swap! data #(sort-by column %))
    (swap! data #(reverse (sort-by column %)))))

(defn sortable-table-header []
  (let [show-arrow? (r/atom nil)
        sort-direction  (r/atom :asc)]
    (fn [{:keys [data unfiltered-data columns]}] @sort-direction
      [table-head {:class (table-head-style)}
       [table-row
        (map-indexed (fn [index column-title]
                       ^{:key (str "header-cell-" column-title)}
                       [table-cell {:class (table-header-1-style)} column-title
                        [table-sort-label {:active (= @show-arrow? column-title)
                                           :direction @sort-direction
                                           :onClick #(do (sort-table-by (nth (:values-sort columns) index) data @sort-direction)
                                                         (reset! sort-direction (if (= @sort-direction :asc) :desc :asc))
                                                         (reset! show-arrow? column-title))}]
                        (when (= @show-arrow? column-title) [:span {:class (close-icon-span-style)
                                                                    :onClick #(do (reset! data @unfiltered-data)
                                                                                  (reset! show-arrow? nil)
                                                                                  (reset! sort-direction :asc))} [close-icon {:size "18px"}]])]) (:names columns))]])))

(defn tick-checkbox-based-on-index [value val array-of-ticked]
  (swap! array-of-ticked #(update %
                                  (.indexOf %
                                            (some (fn [e]
                                                    (when (= (:id value) (:id e)) e)) %))
                                  (fn [e]
                                    (assoc e :ticked val)))))


(defn checkbox-change-fn [value assets-selected array-of-ticked selected-all-ticked? selected?]
  (fn [val]
    (tick-checkbox-based-on-index value val array-of-ticked)
    (when-not val (reset! selected-all-ticked? false))
    (reset! selected? true)
    (if val
      (swap! assets-selected #(conj % (select-keys value [:type :id :name :secondary-id :product-description]))) ;;do for multiselect
      (swap! assets-selected #(remove #{(select-keys value [:type :id :name :secondary-id :product-description])} %)))))

(defn handle-context-menu-fn [context-menu value show-context-menu? right-clicked-item label-clicked-out?]
  (fn [^js/Event e]
    (.preventDefault e)
    (when (nil? @context-menu)
      (reset! context-menu {:mouse-x (+ (.-clientX e) 2) :mouse-y (- (.-clientY e) 6) :type (:type value) :id (:id value) :link (:link value) :name (:name value) :label-clicked-out? label-clicked-out?})
      (reset! right-clicked-item [{:type (:type value)
                                   :id (:id value)}])
      (swap! show-context-menu? not))))

(defn table-cellfor-asset [columns-name value index assets-selected selected-all-ticked? selected? array-of-ticked context-menu show-context-menu? right-clicked-item onChange workspace-id selected-folder-id local-data]
  (let [text-val (r/atom (columns-name value))
        type (:type value)
        id (:id value)
        label-clicked-out? (r/atom false)]
    (fn [columns-name value]
      [table-cell {:class (table-cell-style) :onContextMenu (handle-context-menu-fn context-menu value show-context-menu? right-clicked-item label-clicked-out?) :style {:cursor "context-menu"}}
       [h-box
        :gap "4px"
        :align :end
        :class (product-form-name-component)
        :children [(if (= :name columns-name)
                     [checkbox/checkbox-component {:ticked? (some #(when (= (:id value) (:id %)) (:ticked %)) @array-of-ticked)
                                                   :attr {:on-click #(.stopPropagation %)}
                                                   :onChange (checkbox-change-fn value assets-selected array-of-ticked selected-all-ticked? selected?)}] ())
                   (if (= :name columns-name)
                     (if (:icon value)
                       [h-box
                        :gap "4px"
                        :align :center
                        :children [(:icon value)
                                   [label-text-field {:placeholder "Untitled" :disable false :value text-val
                                                      :onChange #(do (reset! text-val %)
                                                                     (onChange @text-val id type workspace-id selected-folder-id local-data index))
                                                      :focused? true
                                                      :id (str "product-card-name-" (:id value))
                                                      :name @text-val
                                                      :padding "0px 12px"
                                                      :text-val text-val
                                                      :width "100px"
                                                      :label-clicked-out? label-clicked-out?
                                                      :selected false}]]] ())
                     [h-box
                      :children [[:span (columns-name value)]]])]]])))

(defn basic-table-with-checkbox [{:keys [data unfiltered-data columns assets-selected selected-all-ticked? selected? array-of-ticked actions context-menu show-context-menu? right-clicked-item onChange workspace-id selected-folder-id local-data]}]
  (fn [{:keys [data unfiltered-data columns assets-selected selected-all-ticked? selected? array-of-ticked actions context-menu show-context-menu? right-clicked-item onChange workspace-id selected-folder-id local-data]}]
    [v-box
     :children
     [[:<>
       [paper {:class (table-wrapper-style)}
        [table-container {:sx {:maxHeight "calc(100vh - 270px)"}}
         [table  {:stickyHeader "true"
                  :sx {:minWidth 650}
                  :aria-label "sticky table"
                  :class (table-style)}
          [sortable-table-header {:data data :unfiltered-data unfiltered-data :columns columns}]
          [table-body {:class (table-body-style)}
           (doall (map-indexed (fn [index value] @data @array-of-ticked
                                 ^{:key (str "list-item-" (:id value))}
                                 [table-row {:class (table-row-style)
                                             :onClick (if (= "folder" (:type value))
                                                        (:link value)
                                                        #(js/window.location.assign (:link value)))}
                                  (for [columns-name (:values columns)]
                                    [table-cellfor-asset columns-name value index assets-selected selected-all-ticked? selected? array-of-ticked context-menu show-context-menu? right-clicked-item onChange workspace-id selected-folder-id local-data])]) @data))]]]]]
      (when show-context-menu? [table-item-menu-component context-menu show-context-menu? actions])]]))